// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Data Mall",
        pull_refresh: 'Zum Aktualisieren nach unten ziehen',
        release_refresh: 'Zum Aktualisieren loslassen',
        refresh_loading: 'Laden…',
        footer_text: 'Dienstleistungen werden von Ucloudlink (NASDAQ: UCL) bereitgestellt'
    },
    home: {
        input_placeholder: 'Land/Region suchen',
        my_flow: 'Meine Daten',
        charge_code: 'Gutscheincode',
        coupons:'Gutscheine',
        local_package: 'Lokale Daten',
        more: 'Mehr',
        popular_destination: 'Land/Region',
        buy_now: 'Jetzt kaufen',
        package_useing: 'Aktiv',
        unused: 'Inaktiv',
        download_app: 'App herunterladen',
        enter_the_mall_list: 'Zum Einkaufszentrum gehen',
        no_data: 'Keine Daten',
        no_data_available: 'Keine Daten verfügbar',
        copy_success: 'Kopieren erfolgreich',
        copy_fail: 'Kopieren fehlgeschlagen',
        meritsTitle: 'Was sind die Vorteile?',
        merits1: 'Keine SIM erforderlich & Keine monatlichen Gebühren',
        merits2: 'Integriert mit den Top 2-3 Providern für automatischen Netzwerkwechsel',
        go_buy: 'Kaufen gehen',
        instant_savings: 'Sparen',
        expires_in: 'Läuft ab in',
        download_app_tips: "App laden für mehr Angebote & Erlebnisse"
    },
    packages: {
        sub_title: {
            us: 'Ausgenommen Guam, Saipan',
            it: 'Einschließlich Vatikanstadt, San Marino',
            va: 'Einschließlich Italien, San Marino',
            sm: 'Einschließlich Italien, Vatikanstadt',
            ma: 'Einschließlich Westsahara',
            eh: 'Einschließlich Marokko',
            ch: 'Including Liechtenstein',
            li: 'Einschließlich der Schweiz',
            fr: 'Einschließlich Monaco',
            mc: 'Einschließlich Frankreich',
            fi: 'Einschließlich der Aland-Inseln',
            ax: 'Einschließlich Finnland',
            gu: 'Einschließlich der Nördlichen Marianen',
            mp: 'Einschließlich Guam'
        },
        unlimited_packages: 'Unbegrenztes Datenpaket',
        normal_packages: 'Normales Datenpaket',
        multi_region_packages: 'Multiregional',
        regional_data: 'Regionale Daten',
        high_speed_text: 'Hochgeschwindigkeitsdaten',
        infiniteFlow: 'Unbegrenzte Daten',
        unLimitData: 'Unbegrenzt',
        high_speed_text_year: 'hohe Geschwindigkeit/mp',
        package_list: 'Paketliste',
        special_offer: 'Sale',
        first_month: '1. Monat',
        periodUnit: {
            day: 'Tag(e)',
            month: 'Monat',
            hour: 'Std)',
            year: 'Jahr',
        },
        periodUnits: {
            day: 'Tag(e)',
            month: 'Monate',
            hour: 'Std)',
            year: 'Jahre',
        },
        periodUnitSimp: {
            day: 'D',
            month: 'für',
            hour: 'H',
            year: 'Die'
        },
        periodUnitMonthly:'Monatlich',
        periodUnitsSimp: {
            day: 'D',
            month: 'für',
            hour: 'H',
            year: 'Die'
        },
        unlimited_good_name: {
            day: 'Tageskarte',
            month: 'Monatskarte',
            year: 'Jahreskarte'
        },
        continuousMonth: "Kontinuierliche Monate",
        continuousDay: "Kontinuierliche Tage",
        continuousYear: "Kontinuierliche Jahre",

        day_invalid: 'Läuft am aktuellen Tag ab',
        month_invalid: 'Läuft im aktuellen Monat ab',
        immediate_valid: 'Ab sofort wirksam',
        tomorrow_day_valid: 'Gültig ab dem nächsten Tag',
        tomorrow_month_valid: 'Gültig ab nächsten Monat',

        // detail page
        detail: {
            cell_flow: 'Daten',
            cell_period: 'Gültigkeit',
            buy_quantity: 'Menge',
            use_area: 'Abdeckung',
            use_intro: 'Geschäftsbedingungen',
            buy_btn: 'Befehl',
            pay: 'Bezahlen',
            buy_tips: 'Sie haben das %@packageName-Paket in Gebrauch. Möchten Sie dieses Paket kaufen?',
            haveOrderTips: "Zahlungsausstehende Bestellung erstellt. Klicken Sie Bestätigen zur Meine Daten-Seite！"
        },

        // confirm page
        confirm: {
            title: 'Auftragsbestätigung',
            real_pay_amount: 'Gezahlter Betrag',
            online_payment: 'Online-Zahlung',
            create_order_error: 'Die Einrichtung ist fehlgeschlagen'
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: 'Bestellstatus wird angezeigt …',
            buy_success: 'Bestellung abgeschlossen',
            buy_pending: 'Bestätigung steht aus',
            buy_pending_tip: 'Zahlung läuft ... Wenn die Zahlung nicht innerhalb von 10 Minuten überwiesen wurde, wenden Sie sich bitte an uns, um Unterstützung zu erhalten.',
            get_payment_info_fail: 'Die Erfassung der Zahlungsinformationen ist fehlgeschlagen',
            cell_package: 'Paket',
            cell_buy_amount: 'Zwischensumme',
            cell_real_amount: 'Gezahlter Betrag',
            go_to_order_btn: 'Gehen Sie zu „Mein Paket“.',
            back_home: 'Zurück nach Hause',
            back_mall: 'Zurück zum Einkaufszentrum',
            ordersn_empty: 'Die Bestell-SN darf nicht leer sein',
            order_search_error: 'Unerwarteter Fehler',
            goodsName:'Produktname'
        },

        //fail page
        fail: {
            payment_fail: 'Die Zahlung ist fehlgeschlagen',
            back_home: 'Zurück nach Hause'
        }
    },
    CountryGroup: {
        title: "Land/Region",
        placeholder: "Land oder Region suchen",
        clear: "Klar",
        history: "Suchverlauf"
    },
    PromotionCode: {
        verification: {
            title: "Gutscheincode",
            minititle: "Gutscheincode",
            input: "Bitte geben Sie den Aufladecode ein",
            explain: "Tipps: Berühren Sie die Scan-Schaltfläche oben rechts, um den QR-Code der Gutscheinkarte zu scannen, oder geben Sie den Gutscheincode manuell ein (Groß- und Kleinschreibung beachten), wenn dies nicht funktioniert.",
            submit: "Einreichen",
            exchange: "Tilgen",
            cancel: "Stornieren",
            Inquiry: "Möchten Sie unbedingt umtauschen?",
            ErrorCode: "Fehler beim Aufladecode"
        },
        recharge_success: {
            package: "Paket",
            content: "Erfolgreich eingelöst",
            back: "Zurück zum Einkaufszentrum",
            view_packets: "Gehen Sie zu „Mein Paket“."
        }
    },
    order: {
        state: {
            inUse: "Aktiviert",
            isFirst: "Priorisiert",
            toFirst: "Priorität festlegen",
            inactive: "Inaktiviert"  
        },
        periodUnits: {
            minute: "Minute(n)",
            hour: "Std)",
            day: "Tag(e)",
            month: "Monat(e)"
        },
        useIntro: {
            tip1: "Das unbegrenzte Datenpaket hat eine höhere Priorität als das Volumendatenpaket.",
            tip2: "Die Nutzungspriorität basiert auf dem Kaufdatum für den gleichen Pakettyp, d. h. das Paket mit dem frühesten Kaufdatum wird zuerst aufgebraucht, während die Priorität von Einzelregionspaketen höher ist als die von Regionalpaketen.",
            tip3: "Sie können die Priorität der Verwendung von Paketen desselben Typs auch manuell anpassen."
        },
        myFlow: "Meine Daten",
        remainingFlow: "Daten übrig",
        remainingTime: "Gültig links",
        remainingHighFlow: "Hochgeschwindigkeitsdaten übrig",
        validPeriod: "Gültigkeit",
        noneFlow: "Kein Datenpaket",
        noneFlowTip: "Bitte erwerben Sie das Datenpaket und genießen Sie das hochwertige Netzwerk",
        buyPackFlow: "Pakete kaufen",
        checkInvalidFlow: "Überprüfen Sie das abgelaufene Datenpaket",
        orderList: {
            "title": "Meine Bestellungen",
            "amount_paid": "Gesamt",
            "device": "Eigenes Gerät",
            "order_details": "Bestelldetails",
            "total_amont": "Zwischensumme",
            "orderSN": "Bestell-Nr.",
            "createTime": "Schöpfungszeit",
            "cancelTime": "Geschlossene Zeit",
            "payTime": "Bestellzeit",
            "unsubTime": "Abgesagte Zeit",
            "payMethod": "Zahlungsart",
            "thirdSN": "Transaktionsnr.",
            "delete": "Löschen",
            "cancel": "Bestellung stornieren",
            "unsub": "Erstattung",
            "goto_cancel": "Möchten Sie die Bestellung stornieren?",
            "goto_unsubscribe": "Möchten Sie die Bestellung abbestellen?",
            "delete_Tips": "Die Bestellung kann nach dem Löschen nicht wieder aufgenommen werden, daher können Ihre Kundendienstprobleme nicht bearbeitet werden.Möchten Sie es wirklich löschen?",
            "status_success": "Vollendet",
            "status_pending": "Unbezahlt",
            "status_cancel": "Geschlossen",
            "status_unsub": "Abgesagt",
            "payMethod_stripe": "Kreditkarte"
          },
    },
    registerlogin: {
        create_account_tip:"Erstellen Sie ein Konto, starten Sie die exklusive Erfahrung",
        select_country_tip:"Geräte verwenden Land/Region",
        email_name: "Post",
        phone_name: "Telefon",
        email_address: "E-Mail-Adresse",
        password: "Passwort",
        country: "Land",
        select_country: "Wählen Sie ein Land",
        cancel: "Stornieren",
        confirm: "Sicher",
        please_enter: "Bitte geben Sie 6-20 Zeichen ein (Kombination aus Buchstaben, Zahlen oder Symbolen)",
        select_country_tips: "Die Länderauswahl dient zum Betrachten lokaler Pakete. Es kann nach der Registrierung nicht geändert werden. Bitte bestätigen Sie!",
        global_roaming: "Internationaler Domänencode",
        phone_number: "Telefonnummer",
        agree: "zustimmen",
        user_agreement: "Benutzervereinbarung",
        and: "Und",
        privacy_policy: "Datenschutzrichtlinie",
        register_login: "Sich anmelden oder anmelden",
        login_error: "Die Anzahl der Anmeldungen ist zu häufig. Bitte versuchen Sie es später erneut!",
        register_error: "Die Anzahl der Registrierungen ist zu häufig. Bitte versuchen Sie es später erneut!",
        forgot_pwd: "Vergessen Sie das Passwort",
        app_tips: "Melden Sie sich in der App mit diesem Konto an, nachdem Sie sie heruntergeladen haben, um auf weitere Funktionen zuzugreifen.",
        download_app: "Gehen Sie, um die App herunterzuladen",
        rememberPwd: "Denken Sie an Passwort",
        third_login: 'Weiter mit',
        agreement_tips: "Bitte überprüfen Sie das Kontrollkästchen Benutzervereinbarung und Datenschutzrichtlinie",
        selectCountry_tips: "Bitte beachten Sie, dass sich das registrierte Land direkt auf die folgenden Zahlungsmethoden und Währungen auswirkt. Bitte wählen Sie entsprechend Ihrem Bedarf aus.",
        login_error_cancel: "Benutzer hat die Anmeldung abgebrochen",
        login_error_auth: "Erlauben Sie Pop-ups in den Browsereinstellungen",
        device_tips: "Gerät wartet auf Aktivierung. Bearbeitung innerhalb 24 Stunden."
      },
    forgotPwd: {
        forgot_pwd: "Vergessen Sie das Passwort",
        email_address: "E-Mail-Adresse",
        next: "Nächste",
        email_has_been_sent: "Wir haben eine E-Mail an %@email gesendet. Bitte klicken Sie auf den Link und befolgen Sie die Schritte, um Ihr Passwort abzurufen.",
        have_retrieved_it: "Ich habe es gefunden",
        unable_to_receive_email: "Sie können die E-Mail nicht erhalten? Bitte überprüfen Sie, ob es E-Mails von %@email unter Ihrem Spam und gelöschtem Mail-Verzeichnis gibt",
        or: "oder",
        resend: "Wiederholen",
        global_roaming: "Internationaler Domänencode",
        phone_number: "Telefonnummer",
        verification_code_has_been_sent: "Wir haben den Verifizierungscode an:",
        verification_code: "Bestätigungscode",
        no_verification_code_received: "Hat der Verifizierungscode nicht erhalten?",
        please_enter: "Bitte geben Sie 6-20 Zeichen ein (Kombination aus Buchstaben, Zahlen oder Symbolen)",
        reset_password: "Passwort zurücksetzen",
        reset_successful: "Erfolgreich zurücksetzen"
    },
    coupons: {
        coupons_name: "Gutscheine",
        no_coupons: "Noch keine Gutscheine",
        no_data: "Noch keine Daten",
        applicable_to_the_following: "Gutscheine sind für das folgende Datenpaket geeignet"
    },
    digital: {
        title: "Gerät SN",
        purchased: "Meine Einkäufe",
        viewAll: "Mehr",
        skinStore: "Produkt Store",
        completed: "Gekauft",
        goBuy: "Kaufen",
        order: {
            title: "Gekaufte Bestellungen"
        },
        detail: {
            describe: "Beschreibung"
        }
    },
    viewPL: {
        other: 'andere'
    },
    invalidFlow: {
        stateName: "Status",
        state: {
            NOT_ACTIVATED: "Inaktiviert",
            IN_USING: "Verfügbar",
            USE_END: "Erschöpft",
            EXPIRE: "Abgelaufen",
            TRANSFER: "Überweisen",
            UNSUBSCRIBE: "Stornieren",
            VALID: "Gültig",
            INVALID: "Ungültig",
            EXCHANGE_POINTS: "Punkte einlösen"
        },
        noneFlow: "Kein abgelaufenes Datenpaket",
        pageName: "Abgelaufenes Datenpaket"
    },
    flowDetail: {
        title: "Datendetails",
        flow: "Daten",
        validTime: "Datendetails",
        invalidTime: "Gültig bis",
        coverage: "Abdeckung",
        useIntro: "Geschäftsbedingungen",
        purchaseTime: "Gekauft bei",
        subtotal: "Zwischensumme",
        status: "Status",
        cancel: "Stornieren",
        buyAgain: "Kaufen Sie es erneut",
        validity: "Gültigkeit",
        tip: "Beachten",
        cancelTip: "Sind Sie sicher, dass Sie dieses Paket erstatten möchten?",
        dataLeft: "Daten übrig"
    },
    netError: {
        try_again: "Versuchen Sie es erneut",
        net_error: "Kein Netzwerk",
        try_again_desc: "Bitte überprüfen Sie die Netzwerkeinstellungen und versuchen Sie es erneut"
    },
    loadFail: {
        try_again: "Versuchen Sie es erneut",
        load_fail: "Das Laden ist fehlgeschlagen",
        load_fail_desc: "Das Laden der Daten ist fehlgeschlagen. Bitte versuchen Sie es erneut",
        IMEI_Not_Exist: "IMEI ist nicht vorhanden. Bitte versuchen Sie, über den rechten Eingang einzutreten",
        Project_Not_Exist: "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Kundendienst.(01)",
        commonError: "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Kundendienst."
    },
    settlement_Easy_and_convenient: "Einfach und bequem",
    settlement_Great_deal: "Sehr",
    settlement_Safe_and_secure: "Sicher",
    settlement_Autopay_service_regulation: "Autopay -Serviceverordnung",
    settlement_Read: "Lesen",
    settlement_No_coupon: "Kein verfügbarer Gutschein",
    settlement_Subtotal: "Zwischensumme",
    settlement_Coupon: "Coupon",
    settlement_TOTAL: "Gesamt",
    settlement_promotion_tip: "Das Werbeangebot kann nicht in Verbindung mit Gutscheinen verwendet werden",
    settlement_coupon_tip: "Der Gutschein kann nicht in Verbindung mit anderen Werbeangeboten verwendet werden",
    member_myFlow_noList: "Keine Daten",
    detail_se_content: "Ein sicherer, einfacher und bequemer Weg. Sie können sich jederzeit abmelden",
    Enter_Promo_code: "Promotion -Code",
    Enter_Promo_Coupon:"Gutscheine",
    settlement_Not_used_coupon:"Gutschein nicht verwendet",
    settlement_Available_coupon:"Verfügbar",
    settlement_Unavailable_coupon:"Nicht verfügbar",
    please_Enter_Promo_code: "Bitte geben Sie den Promotion -Code ein",
    please_Select_Coupon_use: "Bitte wählen Sie den Gutschein, den Sie verwenden möchten.",
    Buy_Now: "Jetzt kaufen",
    Dont_Use_Any: "Verwenden Sie keine",
    settlement_confirm: "Bestätigen",
    flowDetail_unsubscribe: "Abbestellen",
    flowDetail_unsubscribed: "Abgemeldet",
    flowDetail_isCancelPackage: "Abbestellen dieses Paket?",
    flowDetail_confirmAgreementUnsubscribe: "Sie können nach dem Abbestellen nicht viel haben. Sind Sie sicher, dass Sie sich abmelden möchten?",
    flowDetail_cancel: "Stornieren",
    flowDetail_cancelSuccess: "Abmelden erfolgreich",
    packages_detail_promotion: "Förderung",
    orderTips:{
        "iDay" : "Tag",
        "iDays" : "Tage",
        "iMonth" : "Monat",
        "iMonths" : "Monate",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Bei Ihrem ersten Kauf, Zahlen Sie später %@money/%@periodSymbol, Sie können sich jederzeit abmelden",
        'Monthly_discount':"Speichern Sie %@saveMoney jeweils %@period! Sie können sich jederzeit abmelden ",
        'Ordinary_monthly_package':"Ein sicherer, einfacher und bequemer Weg. Sie können sich jederzeit abmelden",
        "AlreadyPurchased":'Tut mir leid, dass Sie momentan nur ein Datenpaket abonnieren können. Bitte melden Sie sich von “%@” ab und abonnieren Sie später ein beliebiges Paket, das Sie nach Ablauf der gewünschten Seite gewünscht haben.',
        "Contract_recommendation_First":'<label>Mit dem Autopay -Service bei Ihrem ersten Kauf nur bezahlen</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Sie können sich jederzeit abmelden'
        +'<a class="btn">Abonnieren ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Mit dem Autopay -Service nur bezahlen</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Sie können sich jederzeit abmelden'
        +'<a class="btn">Abonnieren ></a></p>',
        "Contract_recommendation_General":"<label>Mit Autopay -Service</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Ein sicherer, einfacher und bequemer Weg. Sie können sich jederzeit abmelden'
        +'<a href="javascript:;" class="btn">Abonnieren ></a></p>',
        'BanlanceDoubleCheck':'Sind Sie sicher, dass Sie mit Guthaben bezahlen möchten?',
    },
    feedback: {
        title: "Rückmeldung",
        placeholder: "Bitte geben Sie das Land ein, das Sie besuchen möchten, oder andere Fragen, und wir werden Ihre Bedürfnisse so schnell wie möglich erfüllen!",
        submit: "Einreichen",
        submit_success: "Erfolgreich eingereicht",
        other_opinions: "Weitere Meinungen",
    },
    view_country_input: 'Bitte geben Sie Ihr Konto ein',
    select_package: {
        title: 'Daten wählen',
        allPackage: 'Alle Daten',
        type: 'Typ',
        flow: 'Daten',
        month_package: 'Monatsplan',
        flow_package: 'Datenpaket',
        time: 'Dauer',
        period: 'Zyklus',
        auto_debit: 'Auto-Einzug Info',
        auto_subscribe: 'Auto-Verlängerung',
        detail: 'Daten Details',
        carrier: 'Unterstützte Anbieter',
        country: 'Abgedeckte Länder',
        notice: 'Kaufleitfaden'
    },
}